/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { type MantineTheme, rem } from '@mantine/core';
import type { ReactNode } from 'react';

import i18n from '@fai/friendli-suite/features/i18n';

export const getContainerTagVariants = (
  theme: MantineTheme,
  options?: { isUsedInHeader?: boolean }
) => ({
  ACCESS_REQUIRED: {
    bg: theme.pf.color.bg.neutral.shade.base,
    borderColor: theme.pf.color.border.neutral.default,
    c: theme.pf.color.fg.neutral.strong,
    children: i18n.t('suite.tag_access_required'),
    tooltipContent: i18n.t('suite.container_access_required_tooltip'),
  },
  DAYS_LEFT: (children: ReactNode, tagOptions?: { isDanger?: boolean }) => ({
    bg: tagOptions?.isDanger ? theme.pf.color.bg.danger.default.base : theme.pf.color.fg.white,
    borderColor: tagOptions?.isDanger ? undefined : theme.pf.color.border.neutral.default,
    c: tagOptions?.isDanger
      ? theme.pf.color.fg.danger.default.base
      : theme.pf.color.fg.neutral.strong,
    children,
  }),
  ENTERPRISE: {
    bg: theme.colors.gray[9],
    c: theme.pf.color.fg.white, // FIXME: use design token and linear-gradient
    children: i18n.t('suite.tag_enterprise'),
  },
  NONE_MEMBER: {
    bg: theme.pf.color.bg.neutral.shade.base,
    borderColor: theme.pf.color.border.neutral.default,
    c: theme.pf.color.fg.neutral.strong,
    children: i18n.t('suite.tag_none'),
    tooltipContent: i18n.t('suite.container_none_member_tooltip'),
  },
  NONE_OWNER: {
    bg: theme.pf.color.bg.neutral.shade.base,
    borderColor: theme.pf.color.border.neutral.default,
    c: theme.pf.color.fg.neutral.strong,
    children: i18n.t('suite.tag_none'),
    tooltipWidth: rem(266),
    tooltipContent: i18n.t('suite.container_none_owner_tooltip', { count: 60 }),
  },
  TRIAL_EXPIRED: {
    bg: theme.pf.color.bg.danger.default.base,
    c: theme.pf.color.fg.danger.default.base,
    children: options?.isUsedInHeader ? i18n.t('suite.expired') : i18n.t('suite.tag_trial_expired'),
    tooltipWidth: rem(270),
    tooltipContent: i18n.t('suite.container_trial_expired_tooltip'),
  },
  TRIAL: {
    bg: theme.colors.lime[0],
    c: theme.colors.lime[9],
    children: i18n.t('suite.tag_trial'),
  },
});
